import { useMemo, useRef } from 'react';

import { ArrowLeftLine, Edit2Line, MapPin2Line } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import { useSearchURL } from '@api/data-loaders/resource';
import { formatShortDate } from '@utils/dateUtil';
import HotelSearchBar, { IHotelSearchBarHandle } from '@domain/hotel/searchBar';
import Button from '@components/Button';
import useSearchBar from '@contexts/searchbar';
import { HotelSearchBarActionType } from '@contexts/searchbar/types/hotel';
import { useAppRouter } from '@contexts/router';
import { useSearchParamsToQuery } from '@hooks/useSearchParamsToQuery';
import { getRoomInformations } from '@utils/utils';

import {
  Drawer,
  HotelDateAndGuestWrapper,
  HotelListMobileHeaderWrapper,
  HotelLocationWrapper,
  MobileHeaderBody,
  NavigationButton,
} from './HotelListMobileHeaderStyle';

const HotelListMobileHeader = () => {
  const hotelSearchBarRef = useRef<IHotelSearchBarHandle>(null);

  const { back } = useAppRouter();
  const query = useSearchParamsToQuery();
  const {
    state: { hotel: state },
    dispatch,
  } = useSearchBar();
  const urlData = useSearchURL();

  const { in: checkInDate, out: checkOutDate, room: rooms } = query;

  const formattedCheckInDate = useMemo(
    () => formatShortDate(checkInDate as string),
    [checkInDate]
  );
  const formattedCheckOutDate = useMemo(
    () => formatShortDate(checkOutDate as string),
    [checkOutDate]
  );

  const guestLabel = getRoomInformations(
    rooms as string,
    checkInDate as string,
    checkOutDate as string
  );

  const handleSubmit = () => {
    hotelSearchBarRef?.current?.triggerHandleSubmit();
  };

  return (
    <>
      <HotelListMobileHeaderWrapper>
        <NavigationButton onClick={back}>
          <CustomIcon
            icon={ArrowLeftLine}
            fontSize={24}
            paletteColor='whiteAlpha600'
          />
        </NavigationButton>
        <MobileHeaderBody>
          <HotelLocationWrapper>
            <CustomIcon icon={MapPin2Line} fontSize={20} paletteColor='white' />
            <span>{urlData?.text}</span>
          </HotelLocationWrapper>
          <HotelDateAndGuestWrapper>
            {`${
              formattedCheckInDate && formattedCheckOutDate
                ? formattedCheckInDate + ' - ' + formattedCheckOutDate
                : ''
            }${
              formattedCheckInDate && formattedCheckOutDate && guestLabel
                ? ', '
                : ''
            }${
              guestLabel?.roomNumber && guestLabel?.message
                ? `${guestLabel.roomNumber} oda ${guestLabel.message}`
                : ''
            }`}
          </HotelDateAndGuestWrapper>
        </MobileHeaderBody>
        <NavigationButton
          onClick={() =>
            dispatch({
              type: HotelSearchBarActionType.SET_IS_DRAWER_OPEN,
              payload: true,
            })
          }
        >
          <CustomIcon
            icon={Edit2Line}
            fontSize={24}
            paletteColor='whiteAlpha600'
          />
        </NavigationButton>
      </HotelListMobileHeaderWrapper>
      <Drawer
        title='Otel Arama'
        open={state.isDrawerOpen}
        onClose={() =>
          dispatch({
            type: HotelSearchBarActionType.SET_IS_DRAWER_OPEN,
            payload: false,
          })
        }
        placement='top'
        footer={
          <Button fullWidth onClick={handleSubmit}>
            Otel Ara
          </Button>
        }
      >
        <HotelSearchBar isHomePage={false} ref={hotelSearchBarRef} />
      </Drawer>
    </>
  );
};

export default HotelListMobileHeader;
